// extracted by mini-css-extract-plugin
module.exports = {"btn":"SimpleButton_btn__1vFd_"};